import script from "./AddCatalogModal.vue?vue&type=script&setup=true&lang=js"
export * from "./AddCatalogModal.vue?vue&type=script&setup=true&lang=js"

import "./AddCatalogModal.vue?vue&type=style&index=0&id=7e7df34a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7e7df34a"]])

export default __exports__